import React, {useContext} from 'react';
import {useTranslation} from 'react-i18next';
import clsx from 'clsx';

import {Theme} from '../contexts/theme';
import {getCountryIconUrl} from '../utils/helpers';

import ArrowIcon from './arrow-icon';

import styles from './standings-group.module.css';

export default function StandingsGroup({
  name,
  teams,
  className,
  onScheduleClick = () => null,
  onTeamClick = () => null
}) {
  const {t} = useTranslation();
  const theme = useContext(Theme);
  const classes = clsx({[styles.table]: true, [className]: className, [styles[`table${theme}`]]: true});
  const headRowClasses = clsx(styles.tableRow, styles[`tableHeadRow${theme}`]);
  const bodyRowClasses = clsx(styles.tableRow, styles.tableBodyRow);
  const cellHeadClasses = clsx(styles.cellHead, styles[`cellHead${theme}`]);

  return (
    <table className={classes}>
      <thead>
        <tr className={headRowClasses}>
          <th className={styles.cellGroupName}>{name}</th>
          <th className={cellHeadClasses}>М</th>
          <th className={cellHeadClasses}>З</th>
          <th className={cellHeadClasses}>П</th>
          <th className={cellHeadClasses}>О</th>
        </tr>
      </thead>
      <tbody>
        {teams.map(({name: teamName, countryCode, games, goalsScored, goalsAgainst, points, id}) => (
          <tr className={bodyRowClasses} key={teamName}>
            <td
              className={clsx(styles.cellBody, styles.cellTeamName)}
              onClick={() => onTeamClick({id, countryCode, teamName})}
            >
              <img
                className={styles.icon}
                src={getCountryIconUrl(countryCode)}
                alt={`Флаг ${teamName}`}
                width={23}
                height={16}
              />
              <span className={styles[`cellTeamNameText${theme}`]}>{teamName}</span>
            </td>
            <td className={styles.cellBody}>{games}</td>
            <td className={styles.cellBody}>{goalsScored}</td>
            <td className={styles.cellBody}>{goalsAgainst}</td>
            <td className={clsx(styles.cellBody, styles.cellPoints)}>{points || 0}</td>
          </tr>
        ))}
        <tr>
          <td
            className={styles.tableButton}
            onClick={onScheduleClick}
          >
            <span className={styles.tableButtonText}>
              {t('bracketWidgetSchedule')}
            </span>
            <ArrowIcon />
          </td>
        </tr>
      </tbody>
    </table>
  );
}
